import axios from "@/libs/axios";

export interface SendDocumentRequest {
  projectId: number;
  signerEmail: string;
  agreementName: string;
  additionalNotes?: string;
}

export interface SendDocumentResponse {
  success: boolean;
  message: string;
  data: {
    agreementId: string;
    agreementName: string;
    status: string;
    signerEmail: string;
    documentUrl: string;
  };
}
export interface AdobeApiResponse {
  success: boolean;
  message: string;
  data: SendDocumentResponse;
}

export const sendDocumentForSignature = async (
  request: SendDocumentRequest
): Promise<AdobeApiResponse> => {
  return axios.post("/adobe/send-document", request);
};
